module.exports = __webpack_public_path__ + "static/foryou-whole-positive.cad01ca8.jpg";